module.exports = __webpack_public_path__ + "img/38_32.2b07a059.png";